import { render } from "./EducationTab.vue?vue&type=template&id=6d84bf39&scoped=true"
import script from "./EducationTab.vue?vue&type=script&lang=js"
export * from "./EducationTab.vue?vue&type=script&lang=js"

import "./EducationTab.vue?vue&type=style&index=0&id=6d84bf39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d84bf39"]])

export default __exports__